import { Route, Routes } from 'react-router-dom';
import React, { useEffect } from 'react';

import { onMessage, getToken } from 'firebase/messaging';
import { messaging } from 'js/library/utils/firebaseUtils';

import 'react-toastify/dist/ReactToastify.css';

//area logada
import Home from 'js/components/Home/Home';
import { Store } from 'js/components/StorePlaces/Store';
import Places from 'js/components/StorePlaces/Places';
import StorePlacesLists from 'js/components/StorePlaces/StorePlacesLists';
import Wallet from 'js/components/Wallet/Wallet';
import Voucher from 'js/components/Wallet/Voucher';
import EditUserInfo from 'js/components/UserForm/EditUserInfo.js';
import Inbox from 'js/components/Inbox/Inbox';
import Organizations from 'js/components/Organizations/Organizations';
import AddOrganizations from 'js/components/Organizations/AddOrganizations';
import HowToUse from 'js/components/HelpPages/HowToUse';
import About from 'js/components/HelpPages/About';
import TalkWithUs from 'js/components/HelpPages/TalkWithUs';

//CAMPANHAS
import SharePromotions from 'js/components/Campaigns/SharePromotions';
import { CampaignImagePollsApproval } from 'js/components/Campaigns/CampaignImagePollsApproval';

//icones
import alert from 'styles/assets/Messages/Alert.png';
import establishment from 'styles/assets/Messages/Establishment.png';
import news from 'styles/assets/Messages/News.png';
import promotion from 'styles/assets/Messages/Promotion.png';
import triibomania from 'styles/assets/Messages/Triibomania.png';
import provider from 'styles/assets/Messages/Provider.png';
import tribomania from 'styles/assets/Messages/Tribomania.png';
import logoTriibo from 'styles/assets/triibo-thumb.png';
import { debounce, getLastUserInfo, trackEventMatomo } from 'js/library/utils/helpers';
import { AddressForm } from '../AddressForm/AddressForm';
import CodeInput from 'js/components/LoginForms/CodeInput';
import PhoneInput from 'js/components/LoginForms/PhoneInput';
import UserForm from 'js/components/LoginForms/UserForm';
import PaymentPage from 'js/components/PaymentPage';
import PaymentConfirmed from 'js/components/PaymentPage/PaymentConfirmed';
import cfac22 from 'js/library/utils/cfac22';
import { createNotificationToken } from 'js/library/utils/API/createNotificationToken';

export default function LoggedRoutes(props) {
  const icons = {
    alert,
    establishment,
    news,
    promotion,
    triibomania,
    provider,
    tribomania,
  };

  const { setOpenState } = props;

  // SEGUNDO PLANO
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then((registration) => {
          // console.log('Service Worker registrado com sucesso:', registration);
        })
        .catch((err) => {
          console.log('Erro ao registrar o Service Worker:', err);
        });
    }
  }, []);

  // PERMISSÃO E RECEBIMENTO EM PRIMEIRO PLANO
  useEffect(() => {
    try {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          getToken(messaging, {
            vapidKey: cfac22('FIREBASE_PUBLIC_VAPID_KEY'),
          })
            .then((currentToken) => {
              if (currentToken) {
                sendToken(currentToken);

                onMessage(messaging, (payload) => {
                  // console.log('Notificação recebida em primeiro plano:', payload);

                  const typeIcon = payload.data?.type;
                  const { body, title } = payload.notification;

                  // Extrai a URL da notificação ou usa a padrão
                  const url =
                    payload.notification?.url || payload.data?.url || 'https://triibo.com.br';

                  const notificationOptions = {
                    body,
                    icon: typeIcon ? `${icons[typeIcon]}` : logoTriibo,
                    data: { url },
                  };

                  const notification = new Notification(title, notificationOptions);

                  // Adiciona o evento de clique
                  notification.onclick = (event) => {
                    event.preventDefault();
                    window.open(url, '_blank');
                  };
                });
              }
            })
            .catch((err) => {
              console.error('Erro ao buscar token:', err);
            });
        }
      });
    } catch (error) {
      console.error('Erro ao solicitar permissão de notificação:', error);
    }
    // eslint-disable-next-line
  }, []);

  const sendToken = async (token) => {
    const { uId } = getLastUserInfo();

    // ClubeId: triibo | PartnerId: mlmtgPFBctdnJeJ9Bz4i_triibo
    const partnerId = 'mlmtgPFBctdnJeJ9Bz4i_triibo';
    // console.log('Enviando token:', token);

    if (uId) {
      try {
        await createNotificationToken(uId, partnerId, token);
        // console.log('Token enviado com sucesso.');
      } catch (error) {
        console.error('Erro ao enviar o token:', error);
      }
    }
  };

  useEffect(() => {
    document.addEventListener(
      'scroll',
      debounce(function (event) {
        const titlePage = event.target.title;

        trackEventMatomo(titlePage, 'scroll', 'lista', titlePage.toLowerCase());
      }, 400)
    );
  }, []);

  return (
    <div className="paper-container">
      {/* <ToastContainer autoClose={4000} /> */}
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/login" element={<PhoneInput />} />

        <Route path="/inserirCodigo" element={<CodeInput />} />

        <Route path="/cadastroUsuario" element={<UserForm />} />

        <Route path="/carteira" element={<Wallet />} />

        <Route path="/carteira/detalhes/:id" element={<Voucher />} />

        <Route path="/meusDados" element={<EditUserInfo />} />

        <Route path="/caixaDeEntrada" element={<Inbox />} />

        <Route path="/ofertas/" element={<StorePlacesLists />} />

        <Route path="/oferta/" element={<Store setOpenState={setOpenState} />} />

        <Route path="/estabelecimento/" element={<Places setOpenState={setOpenState} />} />

        <Route path="/pagamento" element={<PaymentPage setOpenState={setOpenState} />} />

        <Route path="/pagamento-confirmado" element={<PaymentConfirmed />} />

        <Route
          path="/triibos"
          key={window.location.pathname}
          element={<Organizations setOpenState={setOpenState} reloadOrgs={props.reloadOrgs} />}
        />

        <Route path="/addTriibos" element={<AddOrganizations />} />

        <Route path="/como-usar" element={<HowToUse />} />

        <Route path="/sobre" element={<About />} />

        <Route path="/fale-conosco" element={<TalkWithUs />} />

        <Route path="/endereco" element={<AddressForm />} />

        <Route path="/image-approval" element={<CampaignImagePollsApproval />} />

        <Route path="/share-promo" element={<SharePromotions setOpenState={setOpenState} />} />
      </Routes>
    </div>
  );
}

